import type { IndexerMethods, IndexerParams, IndexerResponse } from '@backend/app-indexer-web-types';
import type { BusinessUnit } from '@backend/lib-l10n';

import { getJobsBusinessUnitApiIndexerUrl } from '~/config';

export const callIndexerProxy = async <T = any>(
  businessUnit: string,
  path: string,
  body?: any,
): Promise<{ data: { results: T[]; count: number } }> => {
  const url = getJobsBusinessUnitApiIndexerUrl(businessUnit, path);

  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(`Error on indexer call ${path} for BU ${businessUnit}, status: ${response.status}`);
  }

  const data = (await response.json()) as { results: T[]; count: number };
  return { data };
};

export const callIndexerRPCProxy = async <Method extends IndexerMethods>({
  body,
  businessUnit,
  method,
}: IndexerParams<Method> extends undefined
  ? {
      body?: undefined;
      businessUnit: BusinessUnit;
      method: Method;
    }
  : {
      body: NonNullable<IndexerParams<Method>>;
      businessUnit: BusinessUnit;
      method: Method;
    }) => {
  const url = getJobsBusinessUnitApiIndexerUrl(businessUnit, `rpc/${method}`);

  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(`Error on indexer call ${String(method)} for BU ${businessUnit}, message: ${response.statusText}`);
  }

  return (await response.json()) as IndexerResponse<Method>;
};
